<!--  -->
<template>
  <div class="indentHeader">
    <div class="indentHeader-body">
      <div class="indentHeader-title"><p>{{filterPaymentType(orderDetail.status)}}</p></div>
      <div class="indentHeader-time" v-if="orderDetail.status===1">剩余 <p class="count">{{countDown}}</p> 自动关闭</div>
      <div
        class="indentHeader-time"
        v-if="orderDetail.status===5 || orderDetail.status===4">
        <p class="count">{{orderDetail.cancelType==1?'超时未支付':orderDetail.cancelType==2?'主动取消':'客服取消'}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { orderType } from '../../indentTools';

export default {
  props: {
    orderDetail: {
      type: Object,
    },
    countDown: {
      type: String,
    },
  },
  data() {
    return {
    };
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {
    // 判断支付方式类型
    filterPaymentType(status) {
      return orderType(status);
    },
  },
};

</script>
<style lang="scss" scoped>
.indentHeader{
  display: flex;
  flex-direction: column;
  width: 100%;
  padding:30px 0 34px;
  color: $fontColorBlack;
  &-title{
    margin-bottom: 11px;
    font-weight: 500;
    font-size: 43px;
    line-height: 60px;
    p{
      color: $theme_color;
    }
  }
  &-time{
    display: flex;
    font-weight: 500;
    font-size: 25px;
    line-height: 36px;
    .count{
      margin: 0 5px;
      color: $theme_color;
    }
  }
}
</style>
